import React from 'react';
import { DashboardToDashboardRestrictionTooltipContent } from 'components';
import { getAddContactButtonDisabledTooltipText, isPartnershipRoutableToRoutable } from 'helpers/partnerships';
export const AddContactButtonTooltipContent = ({ partnership }) => {
    const isRegisteredToRegistered = isPartnershipRoutableToRoutable(partnership);
    return (React.createElement(React.Fragment, null, isRegisteredToRegistered ? (React.createElement(DashboardToDashboardRestrictionTooltipContent, null)) : (getAddContactButtonDisabledTooltipText(partnership))));
};
